/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2019-2023 (original work) Open Assessment Technologies SA
 *
 */

import config from '@/config';

/**
 * Returns subdomain
 * @returns {string}
 */
export function getSubdomain() {
    const subdomainUrl = /:\/\/([^/]+)/.exec(window.location.href)[1];
    return subdomainUrl.split('.')[0];
}

/**
 * Returns tenant info according to current subdomain
 * @returns {array|undefined}
 */
export const findTenantBySubdomain = () => {
    const subdomain = getSubdomain();
    let tenants = [];

    // parse tenant from environment variable
    try {
        tenants = config.tenants.map(tenant => ({
            key: tenant.clientId,
            label: tenant.label,
            tenantId: tenant.tenantId,
            subdomain: tenant.subdomain
        }));
        /* eslint-disable no-empty */
    } catch (e) {}

    return tenants.find(element => element.subdomain === subdomain);
};

